// platform
const Web = { id: 'web', name: 'Web' };
const IOS = { id: 'ios', name: 'iOS' };
const Android = { id: 'android', name: 'Android' };
const NodeJS = { id: 'node', name: 'Node.js' };
// code language
const Swift = { id: 'swift', name: 'Swift' };
const Kotlin = { id: 'kotlin', name: 'Kotlin' };
const Java = { id: 'java', name: 'Java' };
const ObjectiveC = { id: 'objectivec', name: 'Objective-C' };
const HTML = { id: 'html', name: 'HTML' };
const Ruby = { id: 'ruby', name: 'Ruby' };
const PHP = { id: 'php', name: 'PHP' };
const Python = { id: 'python', name: 'Python' };
const Go = { id: 'go', name: 'Go' };
const JavaScript = { id: 'js', name: 'JavaScript' };
const TypeScript = { id: 'ts', name: 'TypeScript' };
const Dart = { id: 'dart', name: 'Dart' };
// framework
const React = { id: 'react', name: 'React' };
const Angular = { id: 'angular', name: 'Angular' };
const Vue = { id: 'vue', name: 'Vue' };
const Svelte = { id: 'svelte', name: 'Svelte' };
const Electron = { id: 'electron', name: 'Electron' };
const NextJS = { id: 'nextjs', name: 'Next.js' };
const VanillaJS = { id: 'vanilla', name: 'Vanilla JS' };

export const Languages = [
  Swift,
  ObjectiveC,
  Kotlin,
  Java,
  HTML,
  JavaScript,
  TypeScript,
  Ruby,
  PHP,
  Python,
  Go,
  Dart,
  React,
  Angular,
  Vue,
  Svelte,
  Electron,
  NextJS,
  VanillaJS,
  NodeJS,
  Web,
  IOS,
  Android,
];
